<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="pa-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense>
            <v-col cols="12">
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search..." single-line solo hide-details
                class="custom-v-input"></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
                <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
                  <v-data-table :headers="headers" :items="adminloginactivities" :search="search" :items-per-page="10">
                    <template v-slot:item.sl="{ index }">
                      {{ index + 1 }}
                    </template>
                    <template v-slot:item.name="{ item }">
                      {{ `${item.fname} ${item.lname} ` }}
                    </template>
                    <template v-slot:item.login_time="{ item }">
                      {{
                        item.login_time
                          ? formatMySQLDate(item?.login_time)
                          : "N/A"
                      }}
                    </template>
                    <template v-slot:item.logout_time="{ item }">
                      {{
                        item.logout_time
                          ? formatMySQLDate(item?.logout_time)
                          : "N/A"
                      }}
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ADMINS__ACTIONS } from "@/store/action-types";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "SL", value: "sl", align: "start" },
        { text: "Name", value: "name" },
        { text: "Country", value: "country_name" },
        { text: "IP", value: "ip_address" },
        { text: "Email", value: "email" },
        { text: "Login Time", value: "login_time" },
        { text: "Logout Time", value: "logout_time" },
      ],
    };
  },
  computed: {
    ...mapState("admins", ["adminloginactivities"]),
  },
  methods: {
        //formatMySQLDate is needed for timeformat
    formatMySQLDate,
    ...mapActions("admins", [ADMINS__ACTIONS.GETLOGINACTIVITIES]),
  },
  async mounted() {
    this[ADMINS__ACTIONS.GETLOGINACTIVITIES]();
  },
};
</script>
